import gql from 'graphql-tag';

export default gql`
  mutation removeByIdFileMutation($_id: MongoID!) {
    removeByIdFileMutation(_id: $_id) {
      recordId
      message
      title
    }
  }
`;
